/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  GetBrandDetailQueryResponse,
  GetBrandDetailPathParams,
} from '../../types/GetBrandDetail'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getBrandDetail } from '../../clients/getBrandDetail'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getBrandDetailQueryKey = ({
  id,
}: {
  id: GetBrandDetailPathParams['id']
}) =>
  [{ url: '/api/v1/products/catalog/brands/:id/', params: { id: id } }] as const

export type GetBrandDetailQueryKey = ReturnType<typeof getBrandDetailQueryKey>

export function getBrandDetailQueryOptions(
  { id }: { id: GetBrandDetailPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = getBrandDetailQueryKey({ id })
  return queryOptions<
    GetBrandDetailQueryResponse,
    ResponseErrorConfig<Error>,
    GetBrandDetailQueryResponse,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getBrandDetail(
        { id: id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @description Architecture: READ operation - uses pure DRF pattern.
 * Uses DRF's built-in retrieve() method.
 * @summary Get brand detail
 * {@link /api/v1/products/catalog/brands/:id/}
 */
export function useGetBrandDetail<
  TData = GetBrandDetailQueryResponse,
  TQueryData = GetBrandDetailQueryResponse,
  TQueryKey extends QueryKey = GetBrandDetailQueryKey,
>(
  { id }: { id: GetBrandDetailPathParams['id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetBrandDetailQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getBrandDetailQueryKey({ id })

  const query = useQuery(
    {
      ...getBrandDetailQueryOptions({ id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
